import { ClarificationRequestFormDismissButton } from "./ClarificationRequestFormDismissButton"
import { ClarificationRequestFormHint } from "./ClarificationRequestFormHint"
import { ClarificationRequestFormRoot } from "./ClarificationRequestFormRoot"
import { ClarificationRequestFormTextArea } from "./ClarificationRequestFormTextArea"
import { ClarificationRequestFormUpdatedAt } from "./ClarificationRequestFormUpdatedAt"
import "./styles/_clarification-request-form.scss"

export const ClarificationRequestForm = {
  Root: ClarificationRequestFormRoot,
  UpdatedAt: ClarificationRequestFormUpdatedAt,
  TextArea: ClarificationRequestFormTextArea,
  DismissButton: ClarificationRequestFormDismissButton,
  Hint: ClarificationRequestFormHint
}
